import ContentCurationList from '../content-curation/ContentCurationList'
import ContentCurationItem from '../content-curation/ContentCurationItem'
import ArticleIcon from '../assets/icon-content-type-article'
import QuestionIcon from '../assets/icon-content-type-question'
import AnswerIcon from '../assets/icon-content-type-answer'
import DiscussionIcon from '../assets/icon-content-type-discussion'
import ProductUpdateIcon from '../assets/icon-product-update-type'
import IdeaIcon from '../assets/icon-content-type-idea'
import { z } from 'zod'
import classnames from 'classnames'
import WidgetContainer, { widgetContainerConfig } from '../widget-container'

interface CuratedTopicWithIconAndIdx {
  id: string
  type: 'conversation' | 'question' | 'article' | 'idea' | 'productUpdate'
  url: string
  title: string
  icon?: JSX.Element
  idx?: number
}

interface RecommendationsWidgetProps {
  config: RecommendationsWidgetConfig
  curatedTopics: CuratedTopicWithIconAndIdx[]
}

export const widgetName = 'recommendations'

export const config = z
  .object({
    curatedTopics: z.number().array()
  })
  .merge(widgetContainerConfig)

export type RecommendationsWidgetConfig = z.infer<typeof config>

const Recommendations = (props: RecommendationsWidgetProps) => {
  const { config, curatedTopics = [] } = props
  const topicType = {
    question: <QuestionIcon />,
    article: <ArticleIcon />,
    answer: <AnswerIcon />,
    discussion: <DiscussionIcon />,
    conversation: <DiscussionIcon />,
    productUpdate: <ProductUpdateIcon width={24} height={24} />,
    idea: <IdeaIcon />
  }

  if (!curatedTopics.length) {
    return null
  }

  return (
    <WidgetContainer config={config} widgetName='knowledge-base'>
      <div className={classnames('topic-curation__container', 'full-width', 'custom-featured-topic-list')}>
        <div className='sitewidth'>
          {curatedTopics.length ? (
            <ContentCurationList>
              {curatedTopics.map((item, idx) => {
                item.icon = topicType[item.type]
                item.idx = idx
                return <ContentCurationItem key={item.id} {...item} />
              })}
            </ContentCurationList>
          ) : null}
        </div>
      </div>
    </WidgetContainer>
  )
}

export default Recommendations
